module.exports = __webpack_public_path__ + "static/house-36831bb0f8a88b7076fbd6a01c7114e6.jpg";